import { render } from "./PromotionSidebarButton.vue?vue&type=template&id=c25e0ba4&scoped=true"
import script from "./PromotionSidebarButton.vue?vue&type=script&lang=js"
export * from "./PromotionSidebarButton.vue?vue&type=script&lang=js"

import "./PromotionSidebarButton.vue?vue&type=style&index=0&id=c25e0ba4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c25e0ba4"]])

export default __exports__